import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/campaigns/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
